import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../../screens/login/Login";

function AuthRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
    </Routes>
  );
}

export default AuthRouter;
